import { toast } from 'react-toastify';

export default function getApiErrors(apiErrors) {
  if (apiErrors.errors) {
    Object.keys(apiErrors.errors).forEach((key) => {
      const fieldErrors = apiErrors.errors[key];
      const message = Array.isArray(fieldErrors)
        ? fieldErrors.join(' ')
        : String(fieldErrors);
      toast.error(message);
    });
  } else if (apiErrors.error) {
    toast.error(`${apiErrors.error}`);
  } else {
    toast.error(`${apiErrors.message}`);
  }
}
